import * as React from 'react';
import PropTypes from 'prop-types';
var SvgAchievementsTrophy03Small = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 3h-2V2a1 1 0 00-1-1H5a1 1 0 00-1 1v1H2a1 1 0 00-1 1v3c0 2.093 1.43 4 3 4 .045-.006.09-.015.134-.027.624 3.465 3.46 5.819 7.366 6.006V19h-3a1 1 0 00-.894.553l-1 2A1 1 0 007.5 23h9a1 1 0 00.894-1.447l-1-2A1 1 0 0015.5 19h-3v-2.021c3.906-.187 6.742-2.541 7.366-6.006.044.012.089.021.134.027 1.57 0 3-1.907 3-4V4a1 1 0 00-1-1zM4 10c-1 0-2-1.461-2-3V4h2v6zm18-3c0 1.539-1 3-2 3V4h2v3zm-9.795 4.15c-1.57 0-2.58-.88-2.75-2.39l1.17-.21c.15 1.01.61 1.49 1.58 1.49.76 0 1.23-.39 1.23-1.03 0-.68-.44-1.03-1.3-1.03h-.63v-.97h.55c.72 0 1.2-.35 1.2-.87 0-.55-.43-.91-1.12-.91-.76 0-1.26.39-1.37 1.06l-1.17-.2c.18-1.19 1.17-1.96 2.54-1.96s2.32.77 2.32 1.87c0 .6-.34 1.1-.88 1.36v.02c.65.28 1.07.91 1.07 1.71 0 1.18-.98 2.06-2.44 2.06z"
  }));
});
SvgAchievementsTrophy03Small.defaultProps = {
  height: 24,
  width: 24
};
SvgAchievementsTrophy03Small.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgAchievementsTrophy03Small;